import {
    ALL_DATES,
    FIND_A_BRIDE_BY_NAME_OR_LOGIN,
    ORDER_BY,
    ORDER_BY_DATE_JOINED,
    ORDER_BY_LAST_LOGIN,
    ORDER_BY_USERNAME,
    USERS_DIRECTORY_COUNTRY,
    USERS_DIRECTORY_COUNTY,
    USERS_DIRECTORY_DUE_DATE,
    USERS_DIRECTORY_SEARCH,
} from 'mk/autogenerated/translations/UsersDirectoryForm.f046a8db17aa0d2fe5378b3a532efc3c'
import { countiesUsersDirectorySelectOptions, getPlacesSelectOptionsForCounty } from 'mk/geo';
import styles from 'mk2/apps/users/components/UsersDirectoryForm.mscss';
import UsersList from 'mk2/apps/users/components/UsersList';
import { USERS_DIRECTORY_FORM_NAME } from 'mk2/apps/users/containers/UsersDirectory/UsersDirectory.constants';
import { UserStatsEntity } from 'mk2/apps/users/schemas';
import { monthsFrom1980 } from 'mk2/apps/users/utils';
import { InputField } from 'mk2/components/forms/InputField';
import { Option, SelectField } from 'mk2/components/forms/SelectField';
import { SubmitButton } from 'mk2/components/forms/SubmitButton';
import { Form } from 'mk2/components/Form';
import { Panel } from 'mk2/components/Panel';
import { mkReduxForm, MKReduxFormInjectedProps } from 'mk2/decorators/mkReduxForm';
import React from 'react';

interface OwnProps {
    initialValues: UsersDirectoryFormData;
    currentValues: UsersDirectoryFormData;
    usersStats: UserStatsEntity[];
    isMobile: boolean;
    hasMore: boolean;
    onSearch(values);
}

interface OwnState {
    countyId: number;
    dueDate: string;
    orderBy: string;
}

export interface UsersDirectoryFormData {
    login: string;
    dueDate: string;
    county: number;
    place: number;
    orderBy: string;
}

type Props = OwnProps;

export const orderingSelectOptions: Option[] = [
    {value: '-last_login_time', label: ORDER_BY_LAST_LOGIN},
    {value: 'user__username', label: ORDER_BY_USERNAME},
    {value: '-user__date_joined', label: ORDER_BY_DATE_JOINED},
];

export const dueDatesSelectOptions: Option[] = [
    {value: '', label: ALL_DATES},
    ...monthsFrom1980(),
];

class UsersDirectoryFormComponent extends React.Component<Props & MKReduxFormInjectedProps<UsersDirectoryFormData, Props>, OwnState> {
    public state: OwnState = {
        countyId: this.props.initialValues.county || -1,
        dueDate: '',
        orderBy: 'last_login_time',
    };

    public UNSAFE_componentWillMount() {
        const { initialValues, onSearch } = this.props;
        if (initialValues.county > -1) {
            onSearch(initialValues);
        }
    }

    public render() {
        const { handleSubmit, usersStats, isMobile, hasMore } = this.props;
        return(
            <>
                <Form
                    className={styles.UsersDirectoryForm}
                    onSubmit={handleSubmit}
                >
                    <Panel className={styles.UsersDirectoryForm__searchPanel}>
                        <div className={styles.UsersDirectoryForm__inputWrapper}>
                            <InputField
                                name="login"
                                type="text"
                                label={FIND_A_BRIDE_BY_NAME_OR_LOGIN}
                            />
                        </div>
                        <div className={styles.UsersDirectoryForm__selectsWrapper}>
                            <div className={styles.UsersDirectoryForm__selectWrapper}>
                                <SelectField
                                    name="dueDate"
                                    label={USERS_DIRECTORY_DUE_DATE}
                                    options={dueDatesSelectOptions}
                                    onChange={this.handleSelectDueDate}
                                />
                            </div>
                            <div className={styles.UsersDirectoryForm__selectWrapper}>
                                <SelectField
                                    name="county"
                                    label={USERS_DIRECTORY_COUNTY}
                                    options={countiesUsersDirectorySelectOptions}
                                    onChange={this.handleSelectCounty}
                                />
                            </div>

                            {this.state.countyId === 0 &&
                                <div className={styles.UsersDirectoryForm__selectWrapper}>
                                    <SelectField
                                        name="place"
                                        label={USERS_DIRECTORY_COUNTRY}
                                        options={this.placesOptions()}
                                    />
                                </div>
                            }

                            <div className={styles.UsersDirectoryForm__selectWrapper}>
                                <SelectField
                                    name="orderBy"
                                    label={ORDER_BY}
                                    options={orderingSelectOptions}
                                    onChange={this.handleSelectOrdering}
                                />
                            </div>

                        </div>
                        <SubmitButton
                            className={styles.UsersDirectoryForm__btn}
                            formName={USERS_DIRECTORY_FORM_NAME}
                            label={USERS_DIRECTORY_SEARCH}
                        />
                    </Panel>
                </Form>

                {usersStats.length > 0 &&
                    <Panel className={styles.UsersDirectoryForm__resultsPanel}>
                        <UsersList
                            usersStats={usersStats}
                            isMobile={isMobile}
                            hasMore={hasMore}
                        />
                    </Panel>
                }
            </>

        );
    }

    private handleSelectDueDate = (event) => {
        this.setState({ dueDate: event.currentTarget.value });
    };

    private handleSelectCounty = (event) => {
        this.setState({ countyId: parseInt(event.currentTarget.value, 10) });
    };

    private handleSelectOrdering = (event) => {
        this.setState({ orderBy: event.currentTarget.value });
    };

    private placesOptions = () => {
        return getPlacesSelectOptionsForCounty(this.state.countyId.toString());
    };
}

export const UsersDirectoryForm = mkReduxForm<UsersDirectoryFormData, Props>({
    formName: USERS_DIRECTORY_FORM_NAME,
    onValidate: () => ({/* nothing to do, always valid */}),
    onSave: (values, props) => props.onSearch(values),
    disableDirtyCheck: true,
})(UsersDirectoryFormComponent);
